<template>
  <div class="about-us ">
    <section class="hero">
      <h1 data-aos="fade-up" data-aos-duration="900" class="fw-light text-uppercase fw-bold d-none">Cuidamos tu celular con reparaciones claras, accesorios confiables y atención cercana.</h1>
    </section>

    <section ref="contentSection" class="content bg-black py-5 d-flex align-items-center justify-content-center h-100">
      <div class="container ">
        <p class="fs-2 text-center mb-0">
          <span
            v-for="(line, index) in textLines"
            :key="index"
            class="text-line"
          >
            <span class="line-base">{{ line }}</span>
            <span
              class="line-reveal"
              :style="getRevealStyle(index)"
            >{{ line }}</span>
          </span>
        </p>
      </div>
    </section>
    <section ref="statsSection" class="stats-section py-5">
      <div class="container py-4">
        <h2 data-aos="fade-right" data-aos-duration="800" class="col-lg-8 display-5">
          NUESTROS NÚMEROS HABLAN<br class="d-lg-block d-none">
        POR NOSOTROS
        </h2>
        <p data-aos="fade-right" data-aos-duration="800" data-aos-delay="100" class="col-lg-5 fs-6 text-muted mb-4">
          Desde nuestros inicios, crecimos junto a clientes que confían en nuestro servicio técnico y en nuestra selección de accesorios para celulares. Estos números reflejan compromiso, atención y soluciones concretas.
        </p>
        <div class="row g-0">
          <div data-aos="fade-up" data-aos-duration="700" data-aos-delay="0" class="col-12 col-md-4 stat-item">
            <div class="stat-number">{{ counters[0] }}+</div>
            <div class="stat-label">Productos y repuestos</div>
          </div>
          <div data-aos="fade-up" data-aos-duration="700" data-aos-delay="150" class="col-12 col-md-4 stat-item">
            <div class="stat-number">{{ counters[1] }}+</div>
            <div class="stat-label">Modelos atendidos</div>
          </div>
          <div data-aos="fade-up" data-aos-duration="700" data-aos-delay="300" class="col-12 col-md-4 stat-item">
            <div class="stat-number">{{ counters[2] }}+</div>
            <div class="stat-label">Clientes felices</div>
          </div>
        </div>
      </div>
    </section>

    <section class="quienes-somos-section py-5 mt-5">
      <div class="container py-4 pt-5">
        <div class="row align-items-center g-5">
          <div data-aos="fade-right" data-aos-duration="900" class="col-lg-6 col-12 ps-lg-4 pe-0">
            <div class="qs-img-container">
            </div>
          </div>
          <div data-aos="fade-left" data-aos-duration="900" class="px-4 col-lg-6 col-12">
            <h2 class="display-5 fw-bold mb-2 ">¿QUIÉNES SOMOS?</h2>
            <p class="fs-6 text-muted mb-4">
              En Fix Glass somos un servicio técnico y tienda de accesorios para celulares. Trabajamos con repuestos, fundas, vidrios templados y soluciones pensadas para que tu equipo vuelva a estar listo.
            </p>
            <div class="qs-grid">
              <div data-aos="zoom-in" data-aos-duration="500" data-aos-delay="0" class="qs-card">
                <div class="qs-icon-wrap">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6"/>
                  </svg>
                </div>
                <div class="qs-card-title">Nuestra identidad</div>
                <div class="qs-card-desc">Servicio técnico, accesorios y atención clara.</div>
              </div>
              <div data-aos="zoom-in" data-aos-duration="500" data-aos-delay="100" class="qs-card">
                <div class="qs-icon-wrap">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M9.669.864 8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68zm1.196 1.193.684 1.365 1.086 1.072L12.38 6l.248 1.506-1.086 1.072-.684 1.365-1.51.229L8 11l-1.348-.828-1.51-.229-.684-1.365-1.086-1.072L3.62 6l-.248-1.506 1.086-1.072.684-1.365 1.51-.229L8 1l1.348.828z"/>
                    <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1z"/>
                  </svg>
                </div>
                <div class="qs-card-title">Calidad garantizada</div>
                <div class="qs-card-desc">Repuestos y accesorios seleccionados con criterio.</div>
              </div>
              <div data-aos="zoom-in" data-aos-duration="500" data-aos-delay="200" class="qs-card">
                <div class="qs-icon-wrap">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816a4.5 4.5 0 0 0-1.08-.probably-.18A4 4 0 0 0 1 13c0 1 1 1 1 1zM4.166 11.06A4 4 0 0 0 1 13c0 1 1 1 1 1h3.44A3 3 0 0 1 5 13a3.4 3.4 0 0 1 .166-1.06zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0"/>
                  </svg>
                </div>
                <div class="qs-card-title">+5000 clientes</div>
                <div class="qs-card-desc">Clientes que vuelven por confianza y rapidez.</div>
              </div>
              <div data-aos="zoom-in" data-aos-duration="500" data-aos-delay="300" class="qs-card">
                <div class="qs-icon-wrap">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                    <path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6m0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"/>
                  </svg>
                </div>
                <div class="qs-card-title">Asesoramiento real</div>
                <div class="qs-card-desc">Te orientamos antes, durante y después de la reparación.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="latest-products py-5">
      <div class="container py-4">
        <h2 data-aos="fade-up" data-aos-duration="700" class="text-black display-6 fw-bold mb-1">ÚLTIMOS PRODUCTOS</h2>
        <p data-aos="fade-up" data-aos-duration="700" data-aos-delay="100" class="text-secondary mb-5">Lo más nuevo en nuestro catálogo.</p>
        <ProductsCarousel :products="latestProducts" :isLoading="loadingProducts" :itemsPerSlide="3" />
      </div>
    </section>
    <BrandsSection />
  </div>
</template>

<script>
import ProductsCarousel from '@/components/ProductsCarousel.vue';
import BrandsSection from '@/components/home/BrandsSection.vue';
import { getProducts } from '@/services/products';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default {
  name: 'AboutUs',
  components: { ProductsCarousel, BrandsSection },
  data() {
    return {
      scrollProgress: 0,
      latestProducts: [],
      loadingProducts: true,
      counters: [0, 0, 0],
      statsAnimated: false,
      statTargets: [600, 80, 5000],
      textLines: [
        'FIX GLASS NO ES SOLO UNA TIENDA DE ACCESORIOS.',
        'ES SERVICIO TÉCNICO PARA CELULARES CON REPUESTOS SELECCIONADOS',
        'PARA QUE TU EQUIPO VUELVA A FUNCIONAR SIN VUELTAS.',
         'PANTALLAS, BATERÍAS, FUNDAS Y VIDRIOS.',
        'HECHO PARA CELULARES QUE USÁS TODOS LOS DÍAS.',
      ],
    };
  },
  methods: {
    getRevealStyle(index) {
      const total = this.textLines.length;
      const totalProgress = this.scrollProgress * total;

      let lineProgress = 0;
      if (totalProgress >= index + 1) {
        lineProgress = 1;
      } else if (totalProgress > index) {
        lineProgress = totalProgress - index;
      }

      // left-to-right: clip from the right, decreasing it reveals from the left
      const clipRight = (1 - lineProgress) * 100;
      return {
        clipPath: `inset(0 ${clipRight}% 0 0)`,
      };
    },
    handleScroll() {
      if (!this.$refs.contentSection) return;

      const rect = this.$refs.contentSection.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // start when section top hits 90vh, end when section top is at -50% of its height
      const startReveal = windowHeight * 0.9;
      const endReveal = -rect.height * 0.3;

      let progress = 0;
      if (rect.top <= startReveal) {
        progress = (startReveal - rect.top) / (startReveal - endReveal);
        progress = Math.max(0, Math.min(1, progress));
      }

      this.scrollProgress = progress;
      this._ticking = false;
    },
    onScroll() {
      if (!this._ticking) {
        this._ticking = true;
        window.requestAnimationFrame(() => {
          this.handleScroll();
          this.checkStats();
        });
      }
    },
    checkStats() {
      if (this.statsAnimated || !this.$refs.statsSection) return;
      const rect = this.$refs.statsSection.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85) {
        this.statsAnimated = true;
        this.animateCounters();
      }
    },
    animateCounters() {
      const duration = 1800;
      const steps = 60;
      const interval = duration / steps;
      this.statTargets.forEach((target, i) => {
        let step = 0;
        const timer = setInterval(() => {
          step++;
          const progress = step / steps;
          const ease = 1 - Math.pow(1 - progress, 3);
          this.counters[i] = Math.floor(ease * target);
          if (step >= steps) {
            this.counters[i] = target;
            clearInterval(timer);
          }
        }, interval);
      });
    },
  },
  async mounted() {
    this._ticking = false;
    AOS.init({ once: true, offset: 80 });
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.$nextTick(() => {
      this.handleScroll();
      this.checkStats();
    });
    try {
      const response = await getProducts({ page: 1, page_size: 9 });
      this.latestProducts = response.results || [];
    } catch (e) {
      this.latestProducts = [];
    } finally {
      this.loadingProducts = false;
    }
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  },
};
</script>

<style scoped>

h1{
    font-size: 5rem;
}

@media (max-width: 992px) {
  h1 {
    font-size: 1.5rem;
  }
}
.hero {
  color: white;
  text-align: center;
  height: 800px;
  background-size: cover;
  /* fixed */
  background-attachment: fixed;
  background-position: bottom;
}

/* overlay */
.hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
}

.content {
  min-height: 100vh;
}

.text-line {
  display: block;
  position: relative;
  line-height: 1.3;
}

.line-base {
  display: block;
  color: #3e3e3e;
}

.line-reveal {
  position: absolute;
  inset: 0;
  color: #c8c8c8;
  text-align: center;
  clip-path: inset(0 100% 0 0);
  pointer-events: none;
  font-weight: 600 !important;
}
.line-base{
    font-weight: 600 !important;
}

.stats-section {
  background-color: #d4e0c8;
}

.stat-item {
  padding: 2.5rem 2rem;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.stat-number {
  font-size: 5rem;
  font-weight: 800;
  line-height: 1;
  color: #111111;
  letter-spacing: -2px;
}

@media (max-width: 576px) {
  .stat-number {
    font-size: 3rem;
  }
}

.stat-label {
  margin-top: 0.5rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: #2a4a1f;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* ¿Quiénes somos? */
.quienes-somos-section {
  background-color: #fff;
}

.qs-img-container {
  position: relative;
  width: 100%;
}

.qs-img-container img{
  border-radius: 6px;
}

@media (max-width: 992px) {
  .qs-img-container::before {
    display: none;
  }
}

.qs-image {
  position: relative;
  z-index: 1;
  width: 100%;
  display: block;
  object-fit: cover;
}

.qs-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.qs-card {
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  transition: border-color 0.2s;
}

.qs-card:hover {
  border-color: #a8c89a;
}

.qs-icon-wrap {
  width: 38px;
  height: 38px;
  background: #d4e0c8;
  color: #2a4a1f;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.2rem;
}

.qs-card-title {
  font-size: 1rem;
  font-weight: 700;
  color: #111;
}

.qs-card-desc {
  font-size: 0.78rem;
  color: #888;
  line-height: 1.4;
}
</style>
